/*  @flow */

// import * as React from 'react';

// import { activities } from 'components/Activity/ActivityData';

// import {
//     createRequestExtendContract,
//     updateExtendContract
// } from 'permissions/contract';

// import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';

// This component is used by Contracts Table to display actions on the top of table
// For now the actions Arrays below are empty []

export const actionsListSingle: any = [
  // {
  //     label: 'Extend Contract',
  //     icon: '#icon-extend-contract',
  //     class: '',
  //     tag: activities.extendContract.tag,
  //     action: activities.extendContract.action,
  //     permissions: [
  //         ...createRequestExtendContract,
  //         ...updateExtendContract
  //     ],
  // condition(data: Object, action: Object, callback: Function): React.Node {
  //     return (
  //         <ActionButton
  //             data={data}
  //             action={action}
  //             disabled={data.assets_count < 1}
  //             onActionDrawer={callback} />
  //     );
  // }
  // }
];

export const actionsListMultiple: any = [
  // {
  //     label: 'Extend Contracts',
  //     icon: '#icon-extend-contract',
  //     class: '',
  //     tag: activities.extendContract.tag,
  //     action: 'extendContractMultiple',
  //     permissions: [
  //         ...createRequestExtendContract,
  //         ...updateExtendContract
  //     ],
  // condition(data: Object, action: Object, callback: Function): React.Node {
  //     return (
  //         <ActionButton data={data} disabled={data.assets_count < 1} action={action} onActionDrawer={callback} />
  //     );
  // }
  // }
];
